var map = {
	"./Bootstrap.svg": 4855,
	"./C.svg": 9714,
	"./CSS3.svg": 6655,
	"./Confluence.svg": 7837,
	"./FastAPI.svg": 2739,
	"./Figma.svg": 2741,
	"./Firebase.svg": 408,
	"./Git.svg": 7149,
	"./GitHub.svg": 9330,
	"./HTML5.svg": 7505,
	"./JavaScript.svg": 8370,
	"./Jira.svg": 3879,
	"./Kotlin.svg": 4696,
	"./MaterialUI.svg": 1202,
	"./MongoDB.svg": 399,
	"./MySQL.svg": 555,
	"./Node.js.svg": 8950,
	"./Python.svg": 7177,
	"./React.svg": 8032,
	"./Trello.svg": 4489,
	"./Vue.js.svg": 3912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;